import React, { useState } from 'react'
import Modal from 'components/Modal/Modal'
import Checkbox from 'components/Checkbox'
import { Button, Form } from 'react-bootstrap'
import cn from 'classnames'
import s from './ModalSupprimerFavoris.module.scss'

interface Props {
  show: boolean
  onCancel: () => void
  onConfirm: (doNotShowAnyMore: boolean) => void
}

const ModalSupprimerFavoris = ({
  show,
  onCancel,
  onConfirm,
}: Props): JSX.Element => {
  const [checked, setChecked] = useState(false)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onConfirm(checked)
  }

  return (
    <Modal
      additionalModalClassNames={s.modal}
      show={show}
      title="Supprimer un bien favoris"
      onCloseButtonClick={onCancel}
      body={
        <Form className={s.form} onSubmit={handleSubmit}>
          <h2 className={s.title}>
            Etes-vous sûr(e) de vouloir supprimer ce bien de vos favoris ?
          </h2>
          <Checkbox
            className={s.checkbox}
            checked={checked}
            onChange={() => setChecked((prev) => !prev)}
            label="Ne plus me demander"
          />
          <Button
            size="sm"
            className={cn(s.btn, s.cancel)}
            variant="outline-primary"
            onClick={onCancel}
          >
            Annuler
          </Button>
          <Button size="sm" className={cn(s.btn, s.confirm)} type="submit">
            Confirmer
          </Button>
        </Form>
      }
    />
  )
}

export default ModalSupprimerFavoris
